module.exports = __webpack_public_path__ + "static/media/empty-food.b6288542.png";